/**========================================================================
 *                           imports
 *========================================================================**/
import axios from "axios";
import router from "../router";
import { showErrorAlert } from "../helpers";

/*============================ END OF SECTION ============================*/
let config = require("../config/config");
export default {
	async updateUpsell({ commit }, payload) {
		try {
			payload.data.sessionId = this.state.sessionId;
			let param = payload.param;
			if (payload.param === "add-notreload") {
				param = "add";
			}
			let request = {
				method: "POST",
				url: config.baseUrl + "/api/orderitems/" + param,
				headers: { "Content-Type": "application/json" },
				data: payload.data,
			};

			const result = await axios(request);

			//console.log("api request POST order items", result.data)
			if (payload.param != "add-notreload")
				commit("updateOrderItems", result.data);
			commit("updatePeopleCartList", payload?.people);
		} catch (error) {
			console.error(error);
			showErrorAlert(true);
		}
	},
	async getData({ commit }, payload) {
		try {
			let authorizationHeader = "Authorization";

			const userToken = await this.state.auth.getAcessToken();
			axios.defaults.headers.common[
				authorizationHeader
			] = `Bearer ${userToken}`;
			let url = config.baseUrl + "/api/memberlist";
			if (payload) {
				url = config.baseUrl + "/api/memberlist/" + payload;
			}

			const result = await axios.get(url);

			//console.log("api request")
			const data = result.data;
			commit("updateList", data);
			localStorage.setItem("data", JSON.stringify(data));
			//console.log('data ', data)
		} catch (error) {
			console.error(error);
			showErrorAlert(true);
		}
	},
	async getShippingItems({ commit }) {
		try {
			let authorizationHeader = "Authorization";
			const userToken = await this.state.auth.getAcessToken();

			axios.defaults.headers.common[
				authorizationHeader
			] = `Bearer ${userToken}`;
			const result = await axios.get(config.baseUrl + "/api/shippingitems");

			// console.log("GETTING SHIPPING DATA data ", result.data);

			// let shippingData = result.data || [];

			// shippingData = shippingData.map((sd) => {
			//   if (!sd.attributes) return sd;
			//   const attArray = JSON.parse(sd.attributes) || [];

			// 	const addToPrice = attArray.reduce((accumulator, current) => {
			//     const newValue = current.value ? current.price : 0;
			//     return accumulator + newValue;
			// 	}, 0);

			// 	return {
			// 		...sd,

			// 	}

			// });

			commit("updateBaskets", result.data);
		} catch (error) {
			console.error(error);
			showErrorAlert(true);
		}
	},
	async getOrderItems({ commit }) {
		try {
			let authorizationHeader = "Authorization";
			const userToken = await this.state.auth.getAcessToken();

			axios.defaults.headers.common[
				authorizationHeader
			] = `Bearer ${userToken}`;
			const result = await axios.get(config.baseUrl + "/api/orderItems");

			const data = result.data;

			commit("updateOrderItems", result.data);
			// localStorage.setItem('data', JSON.stringify(data))
			//console.log('GETTING ORDER ITEMS DATA data ', data)
		} catch (error) {
			console.error(error);
			showErrorAlert(true);
		}
	},
	async updateData({ commit }, payload) {
		try {
			let authorizationHeader = "Authorization";
			const userToken = await this.state.auth.getAcessToken();
			axios.defaults.headers.common[
				authorizationHeader
			] = `Bearer ${userToken}`;
			//console.log("payload ", payload)
			let request = {
				method: "POST",
				url: config.baseUrl + "/api/shaliah/" + payload.param,
				headers: { "Content-Type": "application/json" },
				data: payload.data,
			};

			await axios(request);

			// console.log("Shaliah Updated", res.data)
			if (payload.redirect) {
				if (!this.getters.addOptions) {
					router.push("/content/payment").catch((error) => {
						if (error.name != "NavigationDuplicated") {
							throw error;
						}
					});
				} else {
					router.push("/content/promo").catch((error) => {
						if (error.name != "NavigationDuplicated") {
							throw error;
						}
					});
				}
			}
		} catch (error) {
			console.error(error);
			showErrorAlert(true);
		}
	},
	async getUserProfile({ commit }) {
		try {
			let authorizationHeader = "Authorization";

			const userToken = await this.state.auth.getAcessToken();

			axios.defaults.headers.common[
				authorizationHeader
			] = `Bearer ${userToken}`;
			const result = await axios.get(config.baseUrl + "/api/memberprofile");
			//console.log("api request profile options", result.data)
			let data = result.data;
			if (data[0].reciprocity === 1) {
				data[0].reciprocity = true;
			} else {
				data[0].reciprocity = false;
			}
			commit("updateProfile", data);
			localStorage.setItem("profile", JSON.stringify(data));
			// FS.setUserVars({
			//   displayName: data[0].memberUserID,
			//   email: data[0].memberPrimaryEmail,
			//   id: data[0].memberUserID,
			//   organizationID: data[0].organizationID,
			// });
		} catch (error) {
			console.error(error);
			showErrorAlert(true);
		}
	},
	async getShippingCustomOptions({ commit }) {
		try {
			let authorizationHeader = "Authorization";
			const userToken = await this.state.auth.getAcessToken();
			axios.defaults.headers.common[
				authorizationHeader
			] = `Bearer ${userToken}`;
			const result = await axios.get(config.baseUrl + "/api/customshipping");

			//console.log("api shipping custom options", result.data)
			const data = result.data;
			commit("updateShippingCustomOptions", data);
			localStorage.setItem("shippingCustomOptions", JSON.stringify(data));
		} catch (error) {
			console.error(error);
			showErrorAlert(true);
		}
	},
	async getOrganization({ commit }) {
		try {
			let authorizationHeader = "Authorization";

			const userToken = await this.state.auth.getAcessToken();

			axios.defaults.headers.common[
				authorizationHeader
			] = `Bearer ${userToken}`;

			const result = await axios.get(config.baseUrl + "/api/shuls");

			//console.log("api request shul", result.data)
			const data = result.data;
			commit("updateOrganization", data);
			localStorage.setItem("organization", JSON.stringify(data));
			//console.log('organization ', data)
		} catch (error) {
			console.error(error);
			showErrorAlert(true);
		}
	},
	async getCategories({ commit }) {
		try {
			let authorizationHeader = "Authorization";
			const userToken = await this.state.auth.getAcessToken();

			axios.defaults.headers.common[
				authorizationHeader
			] = `Bearer ${userToken}`;

			const result = await axios.get(config.baseUrl + "/api/categories");

			const data = result.data;
			commit("updateCategories", data);
			localStorage.setItem("categories", JSON.stringify(data));
		} catch (error) {
			console.error(error);
			showErrorAlert(true);
		}
	},
	async getPromotions({ commit }) {
		try {
			let authorizationHeader = "Authorization";
			const userToken = await this.state.auth.getAcessToken();

			axios.defaults.headers.common[
				authorizationHeader
			] = `Bearer ${userToken}`;
			const result = await axios.get(config.baseUrl + "/api/promotions");

			//console.log("api request promotions", result.data)
			const data = result.data;
			commit("updatePromotions", data);
			localStorage.setItem("promotions", JSON.stringify(data));
		} catch (error) {
			console.error(error);
			showErrorAlert(true);
		}
	},
	async getCharity({ commit }) {
		try {
			let authorizationHeader = "Authorization";
			const userToken = await this.state.auth.getAcessToken();

			axios.defaults.headers.common[
				authorizationHeader
			] = `Bearer ${userToken}`;

			const result = await axios.get(config.baseUrl + "/api/charity");

			//console.log("api request charity", result.data)
			const data = result.data;
			commit("updateCharity", data);
			localStorage.setItem("charity", JSON.stringify(data));
		} catch (error) {
			console.error(error);
			showErrorAlert(true);
		}
	},
	async getCharityCustom({ commit }) {
		try {
			let authorizationHeader = "Authorization";
			const userToken = await this.state.auth.getAcessToken();
			axios.defaults.headers.common[
				authorizationHeader
			] = `Bearer ${userToken}`;

			const result = await axios.get(config.baseUrl + "/api/charity/custom");

			const data = result.data;
			commit("updateCharityCustom", data);
			//localStorage.setItem('charity', JSON.stringify(data))
		} catch (error) {
			console.error(error);
			showErrorAlert(true);
		}
	},
	async getOrderOptions({ commit }) {
		try {
			let authorizationHeader = "Authorization";
			const userToken = await this.state.auth.getAcessToken();

			axios.defaults.headers.common[
				authorizationHeader
			] = `Bearer ${userToken}`;
			const result = await axios.get(config.baseUrl + "/api/orderoptions");

			//console.log("api request order options", result.data)
			const data = result.data;
			commit("updateOrderOptions", data);
			localStorage.setItem("orderOptions", JSON.stringify(data));
		} catch (error) {
			console.error(error);
			showErrorAlert(true);
		}
	},
	async getSettings({ commit }) {
		try {
			let authorizationHeader = "Authorization";

			const userToken = await this.state.auth.getAcessToken();

			axios.defaults.headers.common[
				authorizationHeader
			] = `Bearer ${userToken}`;

			const result = await axios.get(config.baseUrl + "/api/settings");

			const data = result.data;
			commit("updateSettings", data);
			localStorage.setItem("settings", JSON.stringify(data));
		} catch (error) {
			console.error(error);
			showErrorAlert(true);
		}
	},
	async getLocalDeliveryPricing({ commit }) {
		try {
			let authorizationHeader = "Authorization";
			const userToken = await this.state.auth.getAcessToken();

			axios.defaults.headers.common[
				authorizationHeader
			] = `Bearer ${userToken}`;
			let request = {
				method: "GET",
				url: config.baseUrl + "/api/localdelivery",
				headers: { "Content-Type": "application/json" },
			};
			const result = await axios(request);

			commit("updateLocalDelivery", result.data);
		} catch (error) {
			console.error(error);
			showErrorAlert(true);
		}
	},
	async getMembership({ commit }) {
		try {
			let authorizationHeader = "Authorization";
			const userToken = await this.state.auth.getAcessToken();

			axios.defaults.headers.common[
				authorizationHeader
			] = `Bearer ${userToken}`;

			const result = await axios.get(config.baseUrl + "/api/membership");

			const data = result.data;
			// commit('updateShippingCustomOptions', data)
			// localStorage.setItem('shippingCustomOptions', JSON.stringify(data))
		} catch (error) {
			console.error(error);
			showErrorAlert(true);
		}
	},
	async updateUserProfile({ commit }, payload) {
		try {
			let authorizationHeader = "Authorization";
			const userToken = await this.state.auth.getAcessToken();
			axios.defaults.headers.common[
				authorizationHeader
			] = `Bearer ${userToken}`;
			for (let i in payload[0]) {
				if (payload[0][i] === null && i !== "hasDoorman") {
					payload[0][i] = "";
				}
			}
			// axios.data = payload;
			if (payload[0].reciprocity === true) {
				payload[0].reciprocity = 1;
			} else {
				payload[0].reciprocity = 0;
			}

			let request = {
				method: "put",
				url: config.baseUrl + "/api/memberprofile",
				headers: { "Content-Type": "application/json" },
				data: payload[0],
			};
			const result = await axios(request);

			//console.log("api request PUT profile options", result.data)
			// const data = result.data
			//commit('updateProfile', d)
			//localStorage.setItem('profile', JSON.stringify(payload))
			// commit('showToast', { message: "Profile Updated.", position: 'bottom', type: 'success' })
		} catch (error) {
			console.error(error);
			showErrorAlert(true);
		}
	},
	async updateProfileOptions({ commit }, payload) {
		try {
			let authorizationHeader = "Authorization";
			const userToken = await this.state.auth.getAcessToken();
			axios.defaults.headers.common[
				authorizationHeader
			] = `Bearer ${userToken}`;
			axios.data = payload;
			//console.log("payload ", payload)
			let request = {
				method: "put",
				url: config.baseUrl + "/api/profileoptions",
				headers: { "Content-Type": "application/json" },
				data: payload,
			};
			await axios(request);

			//console.log("api request PUT profile options", result.data)
			// const data = result.data
			// commit('updateProfile', data)
			// localStorage.setItem('profileOptions', JSON.stringify(data))
		} catch (error) {
			console.error(error);
			showErrorAlert(true);
		}
	},
	async updateCustomProfileOptions({ commit }, payload) {
		try {
			let authorizationHeader = "Authorization";
			const userToken = await this.state.auth.getAcessToken();
			axios.defaults.headers.common[
				authorizationHeader
			] = `Bearer ${userToken}`;
			axios.data = payload;
			//console.log("payload ", payload)
			let request = {
				method: "put",
				url: config.baseUrl + "/api/profilecustomoptions",
				headers: { "Content-Type": "application/json" },
				data: payload,
			};
			await axios(request);

			//console.log("api request PUT profile CUSTOM options", result.data)
			// const data = result.data
			// commit('updateProfile', data)
			// localStorage.setItem('profileOptions', JSON.stringify(data))
		} catch (error) {
			console.error(error);
			showErrorAlert(true);
		}
	},
	async getProfileOptions({ commit }) {
		try {
			let authorizationHeader = "Authorization";
			const userToken = await this.state.auth.getAcessToken();
			axios.defaults.headers.common[
				authorizationHeader
			] = `Bearer ${userToken}`;
			const result = await axios.get(config.baseUrl + "/api/profileoptions");

			//console.log("api request profile options", result.data)
			const data = result.data;
			commit("updateProfileOptions", data);
			localStorage.setItem("profileOptions", JSON.stringify(data));
		} catch (error) {
			console.error(error);
			showErrorAlert(true);
		}
	},
	async getTransactions({ commit }) {
		try {
			let authorizationHeader = "Authorization";
			const userToken = await this.state.auth.getAcessToken();
			axios.defaults.headers.common[
				authorizationHeader
			] = `Bearer ${userToken}`;
			let request = {
				method: "GET",
				url: config.baseUrl + "/api/transactions",
				headers: { "Content-Type": "application/json" },
			};

			const result = await axios(request);

			commit("updateTransactions", result.data);
		} catch (error) {
			console.error(error);
			showErrorAlert(true);
		}
	},
	async getSingleTransaction({ commit }, id) {
		try {
			let authorizationHeader = "Authorization";
			const userToken = await this.state.auth.getAcessToken();
			axios.defaults.headers.common[
				authorizationHeader
			] = `Bearer ${userToken}`;
			let request = {
				method: "GET",
				url: config.baseUrl + "/api/transactions/" + id,
				headers: { "Content-Type": "application/json" },
			};
			const result = await axios(request);
			commit("updateSingleTransaction", result.data);
		} catch (error) {
			console.error(error);
			showErrorAlert(true);
		}
	},
	async placeOrder({ commit }, payload) {
		try {
			let request = {
				method: "POST",
				url: config.baseUrl + "/api/order",
				headers: { "Content-Type": "application/json" },
				data: payload,
			};
			const result = await axios(request);

			//console("order response", result.data)

			let res = result.data.toLowerCase();
			if (res.indexOf("success") > -1) {
				let str = res.split(":");
				if (str.length > 1) {
					commit("updateTransaction", str[1]);
				}
				router.push("/content/confirm").catch((error) => {
					if (error.name != "NavigationDuplicated") {
						throw error;
					}
				});
			} else if (res.indexOf("paypal") > -1) {
				let str = res.split(":");
				if (str.length > 1) {
					commit("updateTransaction", str[1]);
				}
				router.push("/content/paypal").catch((error) => {
					if (error.name != "NavigationDuplicated") {
						throw error;
					}
				});
			} else {
				commit("fixTotal");

				commit("showToast", {
					message:
						result.data +
						" Order Cannot Be Processed Now, Please try again later or contact support@happypurim.com",
					position: "bottom",
					type: "error",
				});
			}
		} catch (error) {
			commit("showToast", {
				message:
					"Error: Order Cannot Be Processed Now, Please try again later or contact support@happypurim.com",
				position: "bottom",
				type: "error",
			});
			console.error(error);
			showErrorAlert(true);
		}
	},
	async addShipping({ commit }, payload) {
		try {
			let authorizationHeader = "Authorization";
			const userToken = await this.state.auth.getAcessToken();
			axios.defaults.headers.common[
				authorizationHeader
			] = `Bearer ${userToken}`;
			// console.log("item  for saving ****** ", payload.data);
			let request = {
				method: "POST",
				url: config.baseUrl + "/api/shippingitems/",
				headers: { "Content-Type": "application/json" },
				data: {
					...payload.data,
					//TODO: just for a while, please remove this in the future
					// Attributes: "",
				},
			};
			const result = await axios(request);

			//console("api request POST SHIPPING DATA", result.data)
			commit("updateBaskets", result.data);
			commit("showToast", {
				message: "Gift Basket Added",
				position: "bottom",
				type: "success",
			});
		} catch (error) {
			console.error(error);
			showErrorAlert(true);
		}
	},
	async updateShipping({ commit }, payload) {
		try {
			let authorizationHeader = "Authorization";
			const userToken = await this.state.auth.getAcessToken();
			axios.defaults.headers.common[
				authorizationHeader
			] = `Bearer ${userToken}`;
			//console("payload ", payload)
			let request = {
				method: "PUT",
				url: config.baseUrl + "/api/shippingitems/" + payload.param,
				headers: { "Content-Type": "application/json" },
				data: {
					...payload.data,
					//TODO: just for a while, please remove this in the future
					// Attributes: "",
				},
			};
			const result = await axios(request);

			//console("api request PUT SHIPPING DATA", result.data)
			commit("updateBaskets", result.data);
			commit("showToast", {
				message: "Gift Baskets Updated",
				position: "bottom",
				type: "success",
			});
		} catch (error) {
			console.error(error);
			showErrorAlert(true);
		}
	},
	async getPaymentMethods({ commit }) {
		try {
			let authorizationHeader = "Authorization";
			const userToken = await this.state.auth.getAcessToken();
			axios.defaults.headers.common[
				authorizationHeader
			] = `Bearer ${userToken}`;
			let request = {
				method: "GET",
				url: config.baseUrl + "/api/paymentmethods",
				headers: { "Content-Type": "application/json" },
			};
			const result = await axios(request);

			// console.log("api request  Payment Methods", result.data);
			commit("updatePaymentMethods", result.data);
		} catch (error) {
			console.error(error);
			showErrorAlert(true);
		}
	},
	async getDiscounts({ commit }) {
		try {
			let authorizationHeader = "Authorization";
			const userToken = await this.state.auth.getAcessToken();
			axios.defaults.headers.common[
				authorizationHeader
			] = `Bearer ${userToken}`;
			let request = {
				method: "GET",
				url: config.baseUrl + "/api/discounts",
				headers: { "Content-Type": "application/json" },
			};
			const result = await axios(request);

			//console("api request Discounts", result.data)
			commit("updateDiscounts", result.data);
		} catch (error) {
			console.error(error);
			showErrorAlert(true);
		}
	},
	async getTotal({ commit }) {
		try {
			let authorizationHeader = "Authorization";
			const userToken = await this.state.auth.getAcessToken();
			axios.defaults.headers.common[
				authorizationHeader
			] = `Bearer ${userToken}`;
			let request = {
				method: "GET",
				url: config.baseUrl + "/api/gettotal",
				headers: { "Content-Type": "application/json" },
			};
			const result = await axios(request);

			//console("api request GetTotal", result.data)
			commit("updateTotal", result.data);
		} catch (error) {
			console.error(error);
			showErrorAlert(true);
		}
	},
	async getProfileCustomOptions({ commit }) {
		try {
			let authorizationHeader = "Authorization";
			const userToken = await this.state.auth.getAcessToken();
			axios.defaults.headers.common[
				authorizationHeader
			] = `Bearer ${userToken}`;
			const result = await axios.get(
				config.baseUrl + "/api/profilecustomoptions"
			);

			//console.log("api request custom profile options", result.data)
			const data = result.data;
			commit("updateCustomProfileOptions", data);
		} catch (error) {
			console.error(error);
			showErrorAlert(true);
		}
	},
	async login({ commit }, payload) {
		try {
			const result = await axios.get(
				config.baseUrl + "/api/login/Ari-Green/gree"
			);

			//console.log("payload ", payload)
			//console.log("api request login ", result.data)
			const data = result.data;
			commit("UpdateLoginInfo", data);
			localStorage.setItem("loginInfo", JSON.stringify(data));
			//console.log('data ', data)
		} catch (error) {
			console.error(error);
			showErrorAlert(true);
		}
	},
	setSmartLook({ rootState }) {
		window.smartlook("init", "304eb8a20518ba063b45c48af2c24cd788b303b0", {
			region: "eu",
		});
		window.smartlook("record", {
			forms: true,
			numbers: true,
			emails: true,
			ips: true,
		});
		window.smartlook("identify", rootState.userProfile[0].memberUserID, {
			name: `${rootState.userProfile[0].memberLastName}, ${rootState.userProfile[0].memberFirstName}`,
			organization: rootState.organizationInfo[0].sName,
			organizationId: rootState.organizationInfo[0].id,
		});
	},

	async getAttributesById({ commit }, { id }) {
		try {
			let authorizationHeader = "Authorization";

			const userToken = await this.state.auth.getAcessToken();
			axios.defaults.headers.common[
				authorizationHeader
			] = `Bearer ${userToken}`;
			const url = config.baseUrl + `/api/customshipping/${id}`;

			const result = await axios.get(url);

			//console.log("api request")
			const data = result.data;
			// console.log("attributes ===>", { data });
			return data;
		} catch (error) {
			console.error(error);
			showErrorAlert(true);
		}
	},

	modifyShowSpinner({ commit }, value) {
		commit("modifyShowSpinner", value);
	},
	async getPromotionsHeader({ commit }) {
		try {
			let authorizationHeader = "Authorization";
			const userToken = await this.state.auth.getAcessToken();
			axios.defaults.headers.common[
				authorizationHeader
			] = `Bearer ${userToken}`;
			//console("payload ", payload)
			let request = {
				method: "GET",
				url: config.baseUrl + "/api/PromotionsHeader",
				headers: { "Content-Type": "application/json" },

			};
			const result = await axios(request);

			return result.data;
			// commit("updateBaskets", result.data);
			// commit("showToast", {
			// 	message: "Gift Baskets Updated",
			// 	position: "bottom",
			// 	type: "success",
			// });
		} catch (error) {
			console.error(error);
			showErrorAlert(true);
		}
	},

};
